import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemoveInspectionFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveInspectionFormProps) => {
  const [
    fnRemoveInspectionForm,
    { loading }
  ] = ds.useRemoveInspection();

  const handleSubmit = async (id: string) => {

    await fnRemoveInspectionForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(props.id);
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <></>
    </FormBaseLayout.FC>

  );
};
